import { useId, type ReactNode } from "react";
import { cx } from "../lib/cx";

export interface FieldProps {
  label: ReactNode;
  hint?: ReactNode;
  error?: string | null;
  required?: boolean;
  className?: string;
  /** Recebe os ids para ligar label, dica e erro ao controle (aria-describedby). */
  children: (ids: { id: string; describedBy: string | undefined; invalid: boolean }) => ReactNode;
}

export function Field({ label, hint, error, required, className, children }: FieldProps) {
  const id = useId();
  const hintId = hint ? `${id}-hint` : undefined;
  const errId = error ? `${id}-err` : undefined;
  const describedBy = [hintId, errId].filter(Boolean).join(" ") || undefined;
  return (
    <div className={cx("vx-field", className)}>
      <label className="vx-field__label" htmlFor={id}>
        {label}
        {required ? (
          <span className="req" aria-hidden="true">
            *
          </span>
        ) : null}
      </label>
      {children({ id, describedBy, invalid: Boolean(error) })}
      {hint ? (
        <span className="vx-field__hint" id={hintId}>
          {hint}
        </span>
      ) : null}
      {error ? (
        <span className="vx-field__error" id={errId} role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
}

/** Props comuns dos campos com rótulo. */
export interface LabeledProps {
  label: ReactNode;
  hint?: ReactNode;
  error?: string | null;
  required?: boolean;
  className?: string;
  disabled?: boolean;
  name?: string;
}
